import LoginBox from './src/main'

/* istanbul ignore next */
LoginBox.install = function (Vue) {
  Vue.component(LoginBox.name, LoginBox)
}

export default LoginBox



// WEBPACK FOOTER //
// ./src/views/login/components/LoginBox/index.js